var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('ImageText',{attrs:{"value":_vm.value,"theme":"Sections"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }